import React, { PureComponent } from 'react'
import Router from './Router'
import Login from './routes/Login/Login'
import Auth from './Auth'
import Datafetcher from './utils/datafetcher'

interface Props {}

interface State {
  auth : Auth
  datafetcher : Datafetcher
}

export default class App extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      auth: new Auth(),
      datafetcher: new Datafetcher()
    }
  }

  componentDidMount() {}

  render() {
      return this.state.auth && !this.state.auth.isAuthenticated() ? <Login datafetcher={this.state.datafetcher}></Login>
      :
      <Router datafetcher={this.state.datafetcher}></Router>
    }
}